module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/logo-05442179e7df08db40201193fedec870.svg";